import styled from "styled-components";
import { devices } from "../styles/Breakpoints";

export const DarkBackground = styled.div`
  position: absolute;
  transform: translate(-50%, -50%);
  top: 50%;
  left: 50%;
  z-index: 2;
  width: 100vw;
  height: 100vh;
  opacity: 0.95;
  background-color: ${({ theme }) => theme.colors.black};
`;

export const Modal = styled.div`
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 335px;
  height: 462px;
  background: ${({ theme }) => theme.colors.white};
  color: white;
  z-index: 3;
  border-radius: 16px;
  box-shadow: 0 5px 20px 0 rgba(0, 0, 0, 0.04);
  p {
    color: #000000;
  }

  @media ${devices.tablet} {
    width: 624px;
    height: 420px;
  }
  @media ${devices.desktop} {
    /* margin: 0 20% 0 0; */
    width: 50%;
    /* height: 50%; */
    height: auto;
  }
`;

export const ModalHeader = styled.div`
  background: ${({ theme }) => theme.colors.white};
  overflow: hidden;
  border-top-left-radius: 16px;
  border-top-right-radius: 16px;
  margin: 65px auto 0;

  h3 {
    padding: 10px;
    font-weight: 700;
    font-size: 28px;
    text-align: center;
    color: ${({ theme }) => theme.colors.nrmaBlue};
  }

  @media ${devices.tablet} {
    width: 458px;
    h3 {
      font-size: 32px;
    }
  }
  @media ${devices.desktop} {
    margin: 10% auto 0;

    width: 75%;
    h3 {
      font-size: 56px;
    }
  }
`;

export const CloseModalButton = styled.button`
  cursor: pointer;
  padding: 10px 12px;
  border-radius: 8px;
  border: none;
  background: white;
  position: absolute;
  right: 0;
  top: 0;
  align-self: flex-end;

  @media ${devices.desktop} {
    img {
      width: 75px;
      height: 75px;
    }
  }
`;

export const ModalBody = styled.div`
  margin: 40px 30px 0;

  text-align: center;
  p {
    color: ${({ theme }) => theme.colors.black};
    font-size: 16px;
  }

  @media ${devices.tablet} {
    margin: 64px 86px 0;
  }

  @media ${devices.desktop} {
    p {
      font-size: 24px;
    }
  }
`;

export const ModalButtons = styled.div`
  width: 50%;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 20% auto 0;

  @media ${devices.tablet} {
    flex-direction: row;
    justify-content: center;
    /* margin: 10% auto 0; */
    margin: 10% auto 5%;
  }
`;

export const ModalButtonOne = styled.button`
  background: ${({ theme }) => theme.colors.nrmaBlue};
  color: ${({ theme }) => theme.colors.white};
  width: 120px;
  height: 48px;
  cursor: pointer;
  margin-bottom: 10px;
  /* border-radius: 100px; */
  border: none;
  font-size: 14px;

  @media ${devices.tablet} {
    height: 48px;
    font-size: 16px;
    margin: 0 30px 0 0;
  }

  @media ${devices.desktop} {
    /* font-size: 24px; */
    width: 50%;
  }
`;

export const ModalButtonTwo = styled.button`
  width: 160px;
  height: 40px;
  cursor: pointer;
  border: 2px solid #000e82;
  /* border-radius: 100px; */
  font-size: 14px;
  background: ${({ theme }) => theme.colors.white};
  color: #000000;

  @media ${devices.tablet} {
    height: 48px;
    width: 200px;
    font-size: 16px;
  }

  @media ${devices.desktop} {
    /* font-size: 24px; */
    width: 50%;
  }
`;
